import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';
import { AlarmTypeGroup, AlarmTypeGroupFilters } from '@hakimo-ui/hakimo/types';
import { Column as TableColumn, TableData } from '@hakimo-ui/hakimo/ui-table';
import { Button } from '@hakimo-ui/shared/ui-base';
import { PlusIcon } from '@heroicons/react/24/outline';
import { ActionsAlarmTypeGroup } from '../actions-alarm-type-groups/ActionsAlarmTypeGroup';

export const columns: TableColumn[] = [
  {
    id: 'name',
    name: 'Name',
  },
  {
    id: 'description',
    name: 'Description',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'add-alarm-type',
    name: '',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'actions',
    name: '',
    showAtBreakpoint: 'sm',
  },
];

export function getTableData(
  items: AlarmTypeGroup[],
  onClickAddAlarmType: (alarmTypeGroupId: number) => () => void
): TableData {
  return {
    rows: items.map((alarmTypeGroup) => {
      return {
        id: String(alarmTypeGroup.alarmTypeGroupId),
        cells: [
          {
            value: alarmTypeGroup.name,
          },
          {
            value: alarmTypeGroup.description,
          },
          {
            value: (
              <Button
                onClick={onClickAddAlarmType(alarmTypeGroup.alarmTypeGroupId)}
                variant="icon"
              >
                <PlusIcon className="mr-1 h-5 w-5" />
                Add Alarm Types
              </Button>
            ),
          },
          {
            value: <ActionsAlarmTypeGroup alarmTypeGroup={alarmTypeGroup} />,
          },
        ],
      };
    }),
    columns,
  };
}

export function getSearchParams(
  page: number,
  filters: AlarmTypeGroupFilters,
  pageSize: number
): string {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('pageSize', String(pageSize));

  if (filters.name.values.length > 0) {
    params.set(
      'name',
      filters.name.values.map((item) => item.name).join(SEPARATOR)
    );
  }

  return params.toString();
}
